import React from "react";
import {
  Link as ReactRouterLink,
  NavLink,
  useRouteMatch,
} from "react-router-dom";

import { Breadcrumbs, MenuList } from "@graffer-inc/console-design-kit";

import { useAuthContextV2 } from "../../../../auth-state";
import { PlanError } from "../../../organisms/common/plan-error";
import { BrowserTemplate } from "../../../template/base-template";
import { KintoneExportR } from "./routes";

export const KintoneExportTemplate: React.FC<{
  children: React.ReactNode;
  breadcrumbs?: Array<{ to: string; title: string }>;
}> = ({ breadcrumbs, children }) => {
  const { auth } = useAuthContextV2();
  const showContent = React.useMemo(() => {
    // TODO: グラファーのサポートありで、先行で公開しているテナント (plan === "Package") での見せ方を検討する
    return auth.isProductAvailable("KintoneExport", ["SelfServe"]);
  }, [auth]);
  const { path } = useRouteMatch();

  return (
    <div id="rootWrapper">
      <BrowserTemplate title="kintone へのデータ連携">
        <div className="wrapper">
          {showContent ? (
            <div id="pageWrapper" className="columns" style={{ margin: 0 }}>
              <MenuList
                items={[
                  {
                    header: "kintone へのデータ連携",
                    navItems: [
                      {
                        title: "連携設定一覧",
                        hidden: false,
                        anchor: (props) => (
                          <NavLink
                            {...props}
                            to={KintoneExportR.KintoneExportSettings.link({})}
                          />
                        ),
                        active:
                          path ===
                          KintoneExportR.KintoneExportSettings.link({}),
                      },
                    ],
                  },
                ]}
              />
              <div className="column is-content-pane main">
                <Breadcrumbs
                  list={breadcrumbs ?? []}
                  anchor={({ href = "", ...props }) => (
                    <ReactRouterLink {...props} to={href} />
                  )}
                />
                {children}
              </div>
            </div>
          ) : (
            <PlanError title="kintone へのデータ連携機能" />
          )}
        </div>
      </BrowserTemplate>
    </div>
  );
};
